export const SCOPE_1_COLOR = 'rgba(50, 121, 152, 1)';
export const SCOPE_2_COLOR = 'rgba(194, 78, 75, 1)';
export const SCOPE_3_COLOR = 'rgba(137, 180, 115, 1)';

export const AXIS_Y_T_CO2 = '#99A6A9';
export const AXIS_Y_LABEL = '#A9A04B';

export const AXIS_X_LABEL = '#404D50';
